import React from "react";
import { IoSearchOutline } from "react-icons/io5";
import DateRangePicker from "../../../../components/shared/date-range-picker";

const VehicleViewFilters = ({
    activeTab,
    searchTerm,
    setSearchTerm,
    dateRange,
    setDateRange
}) => {
    if (activeTab === "Overview" || activeTab === "Tires" || activeTab === "Media" ) {
        return null;
    }

    return (
        <div className="flex gap-3 flex-wrap mt-5">
            <div className="bg-white rounded-md px-3 flex border border-border items-center gap-2 w-44 lg:w-72 py-1">
                <IoSearchOutline className="text-gray-500 text-lg" />
                <input
                    type="text"
                    className="bg-transparent outline-none py-1 w-full text-sm text-gray-700"
                    placeholder="Search"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                />
            </div>
            {
                !(activeTab === "ServiceConfig" || activeTab === "Renewals") && <DateRangePicker onChange={setDateRange} />
            }
            
        </div>
    );
};

export default VehicleViewFilters; 